<template>
    <v-row class="pb-4">
        <v-col cols="12" class="text-body-2 d-flex justify-space-between align-center">
            Prescriptions
        </v-col>
      <v-col>
        <v-data-table
            :headers="headers"
            :items="items"
            disable-pagination
            class="elevation-1"
            hide-default-header
            hide-default-footer
            @click:row="handleClick"
            dense
        >
          <template v-slot:item.statusId="{item}">
            <v-chip small outlined :color="statusColor(item.statusId)" dark>
              {{ item.statusId}}
            </v-chip>
          </template>

          <template v-slot:item.clubFitter="{item}">
            {{ item.clubFitter.displayName }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
</template>

<script>
import moment from 'moment';

export default {
  data: () => {
    return {
      headers: [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'Status',
          value: 'statusId',
        },
        {
          text: 'Status',
          value: 'client.displayName',
        },
        {
          text: 'Status',
          value: 'clubFitter',
        },
      ]
    }
  },
    props:{
        items:{
            type: Array,
            required:true
        },
        type: {
            type: String,
            default: () => 'all'
        }
    },
    filters:{
        formatDate (value) {
            if (!value) return '';
            return moment(value).format('DD/MM/YYYY');
        }
    },
    methods:{
        open(id){
            this.$router.push('/prescription/view/'+id);
            this.$emit('close')
        },
      handleClick(item) {
        this.open(item.id)
      },
      statusColor(status){

        const colors = {
          new: 'default',
          quoted: 'warning',
          readyToBuild: 'info',
          built: 'info',
          shipped: 'success',
          cancel: 'error'
        }

        return colors[status] || 'default'

      }
    }
}
</script>